import { createAction, props } from '@ngrx/store';

import { AppSettings } from './app.models';

export const initApp = createAction('[App Page] Init');

export const syncAppState = createAction('[App Page] SyncAppState');

export const loadAppSuccess = createAction('[App/API] Load App Success', props<{ app: AppSettings }>());

export const loadAppFailure = createAction('[App/API] Load App Failure', props<{ error: string }>());

export const toggleHelp = createAction('[App Help] Toggle Help', props<{ open: boolean }>());
